import { useEffect } from "react";

export const useSeo = ({ title, description, canonicalPath, jsonLd }) => {
  useEffect(() => {
    if (title) document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    const prevDesc = meta.content;
    if (description) meta.content = description;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    const prevHref = link.href;
    if (canonicalPath) link.href = `https://purohithconnect.com${canonicalPath}`;

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      meta.content = prevDesc;
      link.href = prevHref;
      if (script) script.remove();
    };
  }, [title, description, canonicalPath, jsonLd]);
};
